const badgeType = {

}

badgeType.sort = [
    {
        "label": "铜",
        "value": "铜",
        "sort": "铜",
        "en":"Bronze"
    },
    {
        "label": "银",
        "value": "银",
        "sort": "银",
        "en":"Silver"
    },
    {
        "label": "金",
        "value": "金",
        "sort": "金",
        "en":"Gold"
    },
    {
        "label": "白金",
        "value": "白金",
        "sort": "白金",
        "en":"platinum"
    },
]

badgeType.attribute = [
    {
        "label": "攻击",
        "value": "攻击",
        "sort": "攻击",
        "en": "Attack"
    },
    {
        "label": "特攻",
        "value": "特攻",
        "sort": "特攻",
        "en":"SpAttack"
    },
    {
        "label": "防御",
        "value": "防御",
        "sort": "防御",
        "en":"Defense"
    },
    {
        "label": "特防",
        "value": "特防",
        "sort": "特防",
        "en":"SpDefense"
    },
    {
        "label": "体力",
        "value": "体力",
        "sort": "体力",
        "en":"HP"
    },
    {
        "label": "移动速度",
        "value": "移动速度",
        "sort": "移动速度",
        "en":"Speed"
    },
    {
        "label": "回复体力",
        "value": "回复体力",
        "sort": "回复体力",
        "en":"HPRecovery",
        "specialLabel": "(每5秒)"
    },
    {
        "label": "普通攻击速度",
        "value": "普通攻击速度",
        "sort": "普通攻击速度",
        "en":"AttackSpeed",
        "isPercent": true
    },
    {
        "label": "会心一击率",
        "value": "会心一击率",
        "sort": "会心一击率",
        "en":"CriticalRate",
        "isPercent": true
    },
    {
        "label": "会心一击增伤",
        "value": "会心一击增伤",
        "sort": "会心一击增伤",
        "en":"CriticalDamamge",
        "isPercent": true
    },
    {
        "label": "招式等待时间",
        "value": "招式等待时间",
        "sort": "招式等待时间",
        "en":"ColddownReduction",
        "isPercent": true,
        "isNegative": true,
    },
    {
        "label": "集结招式计量槽增加速度",
        "value": "集结招式计量槽增加速度",
        "sort": "集结招式计量槽增加速度",
        "en":"UniteChargeRate",
        "isPercent": true
    }
]

badgeType.colors = [
    {
        "label": "黑色",
        "value": "黑色",
        "sort": "黑色",
        "en": "black"
    },
    {
        "label": "蓝色",
        "value": "蓝色",
        "sort": "蓝色",
        "en": "blue"
    },
    {
        "label": "棕色",
        "value": "棕色",
        "sort": "棕色",
        "en": "brown"
    },
    {
        "label": "灰色",
        "value": "灰色",
        "sort": "灰色",
        "en": "gray"
    },
    {
        "label": "绿色",
        "value": "绿色",
        "sort": "绿色",
        "en": "green"
    },
    {
        "label": "深蓝",
        "value": "深蓝",
        "sort": "深蓝",
        "en": "navy"
    },
    {
        "label": "粉色",
        "value": "粉色",
        "sort": "粉色",
        "en": "pink"
    },
    {
        "label": "紫色",
        "value": "紫色",
        "sort": "紫色",
        "en": "purple"
    },
    {
        "label": "红色",
        "value": "红色",
        "sort": "红色",
        "en": "red"
    },
    {
        "label": "白色",
        "value": "白色",
        "sort": "白色",
        "en": "white"
    },
    {
        "label": "黄色",
        "value": "黄色",
        "sort": "黄色",
        "en": "yellow"
    },
]
export default badgeType


// WEBPACK FOOTER //
// ./src/utils/badgeType.js